import React from 'react';
import { Badge, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { LuBadgeCheck, LuExternalLink } from 'react-icons/lu';
import { WebSourceOut } from '@/client';
import { AppExternalLink } from '@/components/ui/app-external-link';
import { resolveFaviconUrl } from '@/utils/faviconUtils';
import ChatResponseWebSourceFavicon from './ChatResponseWebSourceFavicon';

interface ChatResponseWebSourceItemProps {
	webSource: WebSourceOut;
}

const ChatResponseWebSourceItem: React.FC<ChatResponseWebSourceItemProps> = (props: ChatResponseWebSourceItemProps) => {
	const { webSource } = props;
	const isOfficial = webSource.authority_tier === 1;
	const displayDomain = webSource.domain ?? webSource.url;

	return (
		<AppExternalLink
			href={webSource.url}
			color="inherit"
			variant="plain"
			_hover={{ bg: 'surface.subtle', textDecoration: 'none' }}
			display="block"
			borderRadius="xl"
			borderWidth="1px"
			borderColor="border.subtle"
			p={3}
		>
			<HStack align="start" gap={2} minW={0}>
				<ChatResponseWebSourceFavicon src={resolveFaviconUrl(webSource)} />
				<VStack align="stretch" gap={1} minW={0} flex={1}>
					<HStack justify="space-between" align="center" gap={2}>
						<HStack gap={1} minW={0}>
							<Text fontSize="xs" color="fg.muted" lineClamp={1} minW={0}>
								{displayDomain}
							</Text>
							<Icon as={LuExternalLink} boxSize={3} color="fg.muted" flexShrink={0} />
						</HStack>
						{isOfficial && (
							<Badge size="sm" variant="subtle" colorPalette="gray" rounded="full" gap={1} flexShrink={0}>
								<Icon as={LuBadgeCheck} boxSize={3} />
								Official source
							</Badge>
						)}
					</HStack>
					<Text textStyle="label" lineClamp={1}>
						{webSource.title ?? displayDomain}
					</Text>
				</VStack>
			</HStack>
		</AppExternalLink>
	);
};

export default ChatResponseWebSourceItem;
